import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { Button, ExternalLink, NamedLink } from '../../../components';
import config from '../../../config';

import css from './SectionFindTeachingJobsByState.module.css';
import { Link } from 'react-router-dom';

const SectionFindTeachingJobsByState = props => {
  const { stateOptions, content, state, handleGetStarted } = props;

  return <div className={css.sectionHolder}>
    <div className={css.rootTitleHolder}>
      <h2 className={css.rootTitle}>
        {content?.findTitle ?
          content.findTitle :
          <FormattedMessage id='SectionFindTeachingJobsByState.title' />
        }
      </h2>
    </div>


    <p className={css.rootDescription}>
      <FormattedMessage id='SectionFindTeachingJobsByState.subtitle' />
    </p>

    <ul className={css.stateList}>
      {stateOptions.map(i =>
        <li className={css.stateItem}>
          {/*<ExternalLink*/}
          {/*  href={`/s?type=job&pub_state=has_any:${i.key}`}*/}
          {/*  className={css.stateLink}*/}
          {/*>*/}
          {/*  {i.label}*/}
          {/*</ExternalLink>*/}

          <Link className={css.stateLink} to={`/online-teaching-jobs/${i.short}`} >
            {i.label}
          </Link>
        </li>,
      )}
    </ul>

    {/*{!currentUser && (*/}
    {/*  <NamedLink className={css.primaryButton} name='SearchPage' to={{ search: `type=job` }}>*/}
    {/*    <FormattedMessage id='SectionFindTeachingJobsByState.browse' />*/}
    {/*  </NamedLink>*/}
    {/*)}*/}

  </div>;
};

SectionFindTeachingJobsByState.defaultProps = {
  stateOptions: config.custom.stateOptions,
};

export default SectionFindTeachingJobsByState;
